import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import HomePage from "@/pages/HomePage";
import LessonPage from "@/pages/LessonPage";
import GrammarPage from "@/pages/GrammarPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div dir="rtl" className="flex min-h-screen items-center justify-center bg-navy-900 px-6 text-center">
          <div>
            <p className="mb-3 text-lg font-bold text-ink">حدث خطأ غير متوقع</p>
            <p className="text-sm text-ink-soft">أعد تحميل الصفحة للمتابعة.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/lessons/:id" element={<LessonPage />} />
          <Route path="/grammar" element={<GrammarPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-center"
        richColors
        toastOptions={{
          style: { fontFamily: "'IBM Plex Sans Arabic', sans-serif" },
        }}
      />
    </ErrorBoundary>
  );
}

export default App;
